interface AuthenticationSession {
    hasUser: () => boolean;
    refresh: () => void;
    clear: () => void;
}

let session: AuthenticationSession | undefined;
let redirecting = false;

export function registerAuthenticationSession(next: AuthenticationSession): () => void {
    session = next;
    redirecting = false;
    return () => { if (session === next) session = undefined; };
}

export function clearAuthentication(): void {
    session?.clear();
}

export function logout(): void {
    clearAuthentication();
    window.location.href = "/auth/logout";
}

export function redirectToLogin(): void {
    if (redirecting) return;
    redirecting = true;
    window.location.href = "/auth/openiddict?ReturnUrl=" + encodeURIComponent(window.location.pathname + window.location.search);
}

export function handleAuthenticationResponse(response: Response): void {
    if (new URL(response.url, window.location.origin).pathname.replace(/\/$/, "").toLowerCase().endsWith("/getuser")) return;
    if ((response.headers.get("openiddict-user-status") === "unauthenticated" && session?.hasUser()) ||
        response.headers.get("openiddict-user-update") === "true") {
        session?.refresh();
    }
}

export function handleAuthenticationException(response: Response, navigate: (path: string, options: { replace: boolean }) => unknown): void {
    if (response.status === 401) {
        clearAuthentication();
        redirectToLogin();
    } else if (response.status === 403 || response.status === 404) {
        navigate(`/error/${response.status}`, { replace: true });
    }
}
